module.exports = __webpack_public_path__ + "img/prdays-logo-old.c67bfd42.png";